import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import Typography from "@mui/material/Typography"
import { Button } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"

const CERT_TYPE = {
  CURRENT: "current",
  TOTAL: "total",
}

const ModalCertChapterConfirm = ({ open, onClose, onAccept, certType }) => {
  const disclaimerText =
    certType === CERT_TYPE.TOTAL
      ? i18n.t("certChapterConfirm.disclaimerTotal")
      : i18n.t("certChapterConfirm.disclaimerCurrent")

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {i18n.t("certChapterConfirm.title")}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {i18n.t("certChapterConfirm.description")}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {disclaimerText}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button onClick={onClose} color="secondary" variant="text">
          {i18n.t("buttons.cancel")}
        </Button>
        <Button
          onClick={onAccept}
          color="branded"
          variant="contained"
          sx={{ width: 175, height: 36 }}
        >
          {i18n.t("buttons.accept")}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ModalCertChapterConfirm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  certType: PropTypes.oneOf(["current", "total"]),
}

export { CERT_TYPE }

export default ModalCertChapterConfirm
